var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 10.0001V4.42006C24.0001 3.52006 22.9201 3.08006 22.3001 3.72006L14.7001 11.3001C14.3001 11.7001 14.3001 12.3201 14.7001 12.7201L22.2801 20.3001C22.9201 20.9201 24.0001 20.4801 24.0001 19.5801V14.0001C31.4601 14.0001 37.3601 20.8401 35.7201 28.5801C34.7801 33.1201 31.1001 36.7801 26.5801 37.7201C19.4401 39.2201 13.0801 34.3201 12.1201 27.7001C11.9801 26.7401 11.1401 26.0001 10.1601 26.0001C8.96006 26.0001 8.00006 27.0601 8.16006 28.2601C9.40006 37.0401 17.7601 43.5401 27.2201 41.7001C33.4601 40.4801 38.4801 35.4601 39.7001 29.2201C41.6801 18.9601 33.8801 10.0001 24.0001 10.0001Z",
    fill: "#FFF7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.06d53291e41d9079102fe3a3a6df46a0.svg";
export { ForwardRef as ReactComponent };